var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDv360Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2192,
    height: 2428,
    fill: "none",
    viewBox: "0 0 2192 2428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1730.6,949.3c142.5-86.5,328.1-41.1,414.5,101.4c86.5,142.5,41.1,328.1-101.4,414.5 c-3.8,2.3-7.6,4.5-11.4,6.6L460.2,2377.1c-142.5,86.5-328.1,41.1-414.6-101.4c-86.5-142.5-41.1-328.1,101.4-414.6 c3.8-2.3,7.6-4.5,11.4-6.6L1730.6,949.3z",
    fill: "#81C995"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M601,303.7C601.7,137.4,467.4,1.9,301.1,1.2c-21.4-0.1-42.7,2.1-63.7,6.5C96.5,42.3-2,169.5,0,314.7v1798.1 l600.4,10.9L601,303.7z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1737.4,1472.9c145.3,75.3,324.1,27.1,411.9-111.1c84.4-142,37.7-325.6-104.3-410c-1.1-0.6-2.1-1.2-3.2-1.9 L459.2,43C318.3-42.1,135,3.1,49.8,144c-2.1,3.5-4.2,7.1-6.2,10.7C-40,297.8,8.2,481.7,151.3,565.4c1,0.6,2,1.1,3,1.7 L1737.4,1472.9z",
    fill: "#5BB974"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2031.4,1475L600.5,2274.3v-686.6l1135.4-633.1c150.5-83.4,340.2-29,423.6,121.6c7.8,14,14.4,28.6,19.9,43.6 C2222,1258.3,2159.8,1407.6,2031.4,1475z",
    fill: "#81C995"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300.8,
    cy: 2127.8,
    r: 300.2,
    fill: "#1E8E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDv360Icon);
export default __webpack_public_path__ + "static/media/dv360-icon.3c56fe39b064a1378ee0f01e1cb7e901.svg";
export { ForwardRef as ReactComponent };